<template>
  <div>
    <esg-table-without-meta :items="items"
                            :fields="fields"
                            :striped="false"
                            max-height="450px"
                            size="xs">
      <template #cell(scope)="{item, items, field, row, col, value}">
        <td v-if="item.rowspan"
            :rowspan="item.rowspan"
            class="text-center">{{ value === 1 ? 'Scope 1' : 'Scope 2' }}
        </td>
        <td v-else
            style="display: none"></td>
      </template>
      <template #cell(abatement_method_name)="{item, items, field, row, col, value}">
        <td :class="{subtotal: value === '소계'}"
            class="text-center">{{ value }}
        </td>
      </template>
      <template #cell(cost_total)="{item, items, field, row, col, value}">
        <td :class="{ subtotal: item.abatement_method_name === '소계'}"
            class="text-center">{{ formatNumber(value / 10e8, 0, 2) }}
        </td>
      </template>
      <template #cell(share)="{item, items, field, row, col, value}">
        <td :class="{ subtotal: item.abatement_method_name === '소계'}"
            class="text-center">{{ formatNumber(value * 100, 0, 2) + '%' }}
        </td>
      </template>
      <template #footer>
        <tr>
          <td colspan="2"
              class="text-center total">합계
          </td>
          <td class="text-center total">{{ formatNumber(total / 10e8, 0, 2) }}</td>
          <td class="text-center total">100%</td>
        </tr>
      </template>
    </esg-table-without-meta>
  </div>
</template>
<script>
import EsgTableWithoutMeta from "@/components/esg/base/EsgTableWithoutMeta.vue";

export default {
  components: {EsgTableWithoutMeta},
  props: {
    corporation: {
      type: Object,
      default() {
        return {}
      }
    },
    businessLocation: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  watch: {
    corporation: {
      deep: true,
      handler() {
        this.fetchData();
      }
    },
    businessLocation: {
      deep: true,
      handler() {
        this.fetchData();
      }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let args = {groupKeys: ['scope', 'abatement_method_value', 'abatement_method_name']};
        this.corporation.name && (args.corporations = [this.corporation.code])
        this.businessLocation.name && (args.businessLocations = [this.businessLocation.business_location_code])

        let data = new FormData()
        data.append('path', 'esg/cost/main');
        data.append('json', JSON.stringify([args]));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: {Authorization: accessToken()},
          signal: this.abortController.signal
        });

        // If there is no data, return
                if (!response.data.data) {
          this.series = [];
          return;
        }


        // Parse JSON data
        let tableData = JSON.parse(response.data.data)[0].data;

        // Set row span for 'scope' field
        let items = [];
        let headerRow = null;
        tableData.forEach((item, index) => {
          items.push(item);

          if (index === 0 || item.scope !== tableData[index - 1].scope) {
            headerRow = item;
            headerRow.rowspan = 2;
            headerRow.subtotal = headerRow.cost_total;
          } else {
            headerRow.rowspan += 1;
            headerRow.subtotal += item.cost_total;
          }

          if (index === tableData.length - 1 || item.scope !== tableData[index + 1].scope) {
            items.push({abatement_method_name: '소계', cost_total: headerRow.subtotal})
          }
        });

        // Calculate total and push it to the items
        this.total = tableData.reduce((a, b) => a + b.cost_total, 0);

        // Calculate share of each cost
        items.forEach(item => item.share = item.cost_total / this.total)

        this.items = items;
      } catch (error) {
        this.loading = false;
        await this.showError(error)
      } finally {
        this.loading = false;
      }
    },
  },
  data() {
    return {
      loading: false,
      total: 0,
      items: [],
      fields: [
        {
          name: 'scope',
          label: 'Scope',
          list: true
        },
        {
          name: 'abatement_method_name',
          label: '감축수단',
          list: true
        },
        {
          name: 'cost_total',
          label: '비용 (억원)',
          list: true,
          formatter: val => this.formatNumber(val / 10e8, 0, 2)
        },
        {
          name: 'share',
          label: '비율',
          list: true,
          formatter: val => this.formatNumber(val * 100, 0, 2) + '%'
        }
      ]
    }
  },
}
</script>

<style scoped>
>>> td.total,
td.subtotal {
  background-color: #FAFAFA;
  font-weight: 700 !important;
}
</style>